export const veridionPageNL = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | De organisatie van AI-medewerkers",
    "description": "De volgende stap in productiviteit: Organisation as a Service. Een organisatie van AI-medewerkers levert gecontroleerd werk, planbaar in vaste cycli, on-premises of in uw eigen cloud."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "Eén schepper, oneindig veel oplossingen.",
    "claim": "De volgende stap in productiviteit: Organisation as a Service.",
    "lead": "De bedrijfs-AI die de hele pAIoneer Labs GmbH aanstuurt: een personeelsbestand van AI-medewerkers dat zich in elk proces van uw onderneming integreert, werk zelfstandig tot het einde brengt en met elke taak bijleert. Mensen geven de richting aan. Al het andere gebeurt vanzelf."
  },
  "vision": {
    "lines": [
      "Software gaf bedrijven gereedschap.",
      "AI gaf hun assistenten.",
      "Veridion geeft hun een organisatie."
    ],
    "note": "Informatie beweegt in uren, ervaring gaat met pensioen, vacatures blijven open. Nog een gereedschap erbij lost dat niet op; een personeelsbestand dat u niet hoeft aan te nemen, lost het wel op."
  },
  "grow": {
    "title": "Wat het niet kan, creëert het zelf",
    "text": "Waar voor een taak nog geen vaardigheid bestaat of iets met bestaande middelen niet lukt, ontwikkelt Veridion zelf nieuwe, willekeurig complexe AI-systemen — AI ontwikkelt AI zelfstandig verder: ontworpen, gebouwd, getest en in gebruik genomen. Alleen de vrijgave ligt bij de mens via [Intent-Driven Development](idd) (IDD).",
    "punch": "Precies dat betekent: één schepper, oneindig veel oplossingen."
  },
  "integrate": {
    "title": "Midden in uw processen",
    "subtitle": "Geen nieuwe software, geen training, geen migratie.",
    "cards": [
      {
        "title": "In de bedrijfschat",
        "text": "Gesproken wordt waar uw mensen toch al schrijven: Webex, Microsoft Teams, Zoom, Slack. Eén bericht volstaat."
      },
      {
        "title": "In uw gereedschap",
        "text": "Projectmanagement, repositories, archieven: gewerkt wordt in de systemen die er zijn, niet eromheen."
      },
      {
        "title": "Van offerte tot boekhouding",
        "text": "Het ene proces na het andere, in uw tempo. Bij krappe capaciteit ook een enkel ontwikkelpakket of een heel project."
      }
    ]
  },
  "org": {
    "title": "Een personeelsbestand, georganiseerd als een onderneming",
    "subtitle": "Wij dringen geen enkel bedrijf een star sjabloon op: voor elke bedrijfsstructuur ontwerpen wij een individueel organigram, wijzen duidelijke rollen en verantwoordelijkheden toe en passen ons flexibel aan. Elke Business Unit bestaat uit AI-medewerkers die door Veridion worden georkestreerd en tot aan de [IDD](idd)-Human-in-the-Loop volledig geautomatiseerd werken — en wanneer iets nog niet kan, ontwikkelt Veridion zelf nieuwe AI.",
    "execKicker": "Coördinatielaag — volledig geautomatiseerd tot aan de IDD Human-in-the-Loop",
    "execTitle": "Individueel organigram, duidelijke rollen en AI die AI zelf verder ontwikkelt.",
    "execText": "Onder de menselijke beslissers werken de coördinatielaag en de Business Units van AI-medewerkers volledig geautomatiseerd: zij splitsen doelen op, verdelen werk over duidelijk gedefinieerde rollen en verantwoordelijkheden, lossen problemen zelfstandig op en vragen gerichte vrijgaven aan de mens. De mens in de loop stuurt via [Intent-Driven Development](idd) (IDD) — ver voorbij softwarecode als gezamenlijke aansturing van mens en AI over intenties, beslissingen en testscenario’s. En telkens wanneer een vaardigheid ontbreekt, ontwikkelt Veridion zelfstandig nieuwe, willekeurig complexe AI-systemen — AI ontwikkelt AI verder.",
    "units": [
      {
        "name": "Softwareontwikkeling",
        "text": "Is verantwoordelijk voor software van de eis tot het beheer: architectuur, code, tests, reviews, pipelines en de kwaliteit daarachter."
      },
      {
        "name": "Elektronica & firmware",
        "text": "Is verantwoordelijk voor de hardwarekant: schakelingen, firmware en de keuze van elke component."
      },
      {
        "name": "Quantum computing & quantum-AI",
        "text": "Is verantwoordelijk voor het onderzoek naar quantum computing en quantum-AI en maakt van solide resultaten producten."
      },
      {
        "name": "Sales & marketing",
        "text": "Is verantwoordelijk voor de markt: volgt die, vindt doelklanten, stelt dossiers op, ontwerpt teksten en offertes. Afsluiten doet een mens."
      },
      {
        "name": "Producten & platformbeheer",
        "text": "Is verantwoordelijk voor producten en beheer: strategie, prioriteiten, releases, daarnaast bewaking, storingen en capaciteit van het draaiende platform."
      },
      {
        "name": "Administratie & financiën",
        "text": "Is verantwoordelijk voor de zakelijke kant: bonnen, facturen, contracten, termijnen, voorbereid tot aan de handtekening, en die blijft bij u."
      }
    ]
  },
  "trust": {
    "title": "Waarop u kunt vertrouwen",
    "cards": [
      {
        "title": "Human-in-the-Loop & IDD ver voorbij code",
        "text": "Intent-Driven Development ([IDD](idd)) reikt veel verder dan softwarecode: het is wat de mens in de loop samen met de AI doet in alle onderdelen van het bedrijf. Mens en AI formuleren samen de bedoeling (Intent), nemen bindende beslissingen (Decisions) en definiëren toetsbare scenario’s (Scenarios), voordat de AI-bezetting in vaste, planbare cycli zelfstandig uitvoert en de mens gericht vrijgeeft."
      },
      {
        "title": "Speltheoretisch geoptimaliseerde communicatie",
        "text": "Het projectmanagement en de communicatie van de AI-medewerkers zijn speltheoretisch geoptimaliseerd, van de individuele AI-medewerker tot de hele business unit: grondigheid en onderbouwde tegenspraak betalen zich terug; afstempelen, herhalen en verantwoordelijkheid doorschuiven kosten. Zo wint de beste communicatie."
      },
      {
        "title": "Uitlegbaar tot aan de bron",
        "text": "Explainable AI is hier het werkprincipe, geen toevoeging: elk resultaat legt open waaruit het is ontstaan, de vindplaatsen in de bedrijfskennis, de gegevens, de rekenstappen. Wat geen onderbouwing heeft, wordt niet beweerd."
      },
      {
        "title": "Leert zelfstandig",
        "text": "De eigen kengetallen worden na elke doorloop gelezen, de eigen regels daarop bijgesteld: elk lopend project maakt het geheel beter."
      }
    ]
  },
  "daily": {
    "title": "Wat vandaag al wordt overgenomen",
    "subtitle": "Elke dag, dwars door de onderneming.",
    "items": [
      {
        "title": "Ontwikkeling",
        "text": "Code, tests en documentatie uit vastgelegde beslissingen. Modernisering van gegroeide software met golden-master- en back-to-back-bewijs."
      },
      {
        "title": "Elektronica & firmware",
        "text": "Datasheets analyseren, schakelingen als digitale tweelingen simuleren, firmware ontwikkelen en componentalternatieven beoordelen voordat er iets wordt gebouwd, dicht op de hardware tot aan de sensor."
      },
      {
        "title": "Quantumonderzoek",
        "text": "De stand van de techniek lezen, reproduceerbare experimenten tegen klassieke vergelijkingsbases opbouwen en evalueren, elk resultaat navolgbaar vastgelegd."
      },
      {
        "title": "Data-analyse",
        "text": "SQL Server, MariaDB, MySQL en Oracle: een getypeerd analyseplan, uitsluitend lezende query’s, statistiek uit de runtime, rapporten uit één geversioneerd resultaat."
      },
      {
        "title": "Administratie & financiën",
        "text": "Boekhouding, financiële verslaglegging en de bureaucratie van een vennootschap: bonnen lezen, toewijzen, archiveren; concepten voor facturen en contracten inbegrepen."
      },
      {
        "title": "Projecten & taken",
        "text": "Uit een meeting-transcript ontstaan zonder omweg taken in het projectmanagement, en de voortgang vloeit terug: de volgende meeting begint bij de actuele stand."
      },
      {
        "title": "Bedrijfskennis",
        "text": "Een kennisbank voor documenten en een grafendatabase die taken, beslissingen, personen en systemen verbindt: samenhang over weken en projectgrenzen heen."
      },
      {
        "title": "Onderzoek op internet",
        "text": "Wat de bedrijfskennis niet heeft, wordt onderzocht: er wordt gezocht, de beste pagina’s worden gelezen, en aan het eind staat een rapport waarin elke uitspraak zijn genummerde bron heeft."
      },
      {
        "title": "Spraak & meetings",
        "text": "Het hele bedrijf is mobiel aan te sturen: gesproken gesprekken doen hetzelfde werk als de chat, ook onderweg op de telefoon."
      },
      {
        "title": "Kantoorwerk met RoBuddy",
        "text": "RoBuddy dekt de werkplek af: afspraken, e-mails, trainingen en vragen over gegevensbescherming. De units dekken de rest van de onderneming."
      }
    ]
  },
  "operate": {
    "title": "Beheer",
    "cards": [
      {
        "title": "On-premises of eigen cloud",
        "text": "Vooraf rekenen we samen uit welke processen renderen: return on investment en totale kosten liggen open. Gedraaid wordt op uw hardware of in uw eigen cloud, zonder dat een document het huis verlaat."
      },
      {
        "title": "Bij ons",
        "text": "pAIoneer Labs GmbH is van de grond af zo opgebouwd: onze projecten, onze bedrijfskennis en onze administratie lopen erover. De organisatie ontwikkelt de [tradingassistent](finance) op ons platform zelf en is de AI in zijn chat."
      }
    ]
  },
  "cta": {
    "title": "Aanvraag",
    "subtitle": "Als serversoftware in uw infrastructuur. De prijs noemen we op aanvraag.",
    "button": "Aanvraag versturen",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
